// CSS
import '@/assets/css/extra-service.scss';
import "@/assets/responsive/extra-service.scss";
// Event, Dialog

// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_EXTRA_SERVICE_API } from "@/constant/apiSettings";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import {
    EXTRA_SERVICE_STATUS_TEXT,
    EXTRA_SERVICE_STYLE_STATUS_TEXT,
    DESCRIPTION_REQUEST, PRE_FIX_REQUEST,
    UNIT_REQUEST,
    EXTRA_SERVICE_STATUS_ICON,
    EXTRA_SERVICE_REQUEST_STATUS,
} from "@/constant/extraService";

// Extend
import base from '@/scripts/base';

// Components
import RequirementPaid from "@/views/component/ExtraService/RequirementPaid";
import CommonNote from "@/views/component/ExtraService/CommonNote";
import NoMachineFixedRental from "@/views/component/ExtraService/Notification/NoMachineFixedRental";
import CurrentLessThanRequestValue from "@/views/component/ExtraService/Notification/CurrentLessThanRequestValue";
import RequestAlreadyExists from "@/views/component/ExtraService/Notification/RequestAlreadyExists";
import NoDeposit from "@/views/component/RentalService/Notification/NoDeposit";
import NotPrime from "@/views/component/ExtraService/Notification/NotPrime";

export default {

    extends: base,

    components: {
        RequirementPaid,
        CommonNote,
        NoMachineFixedRental,
        CurrentLessThanRequestValue,
        RequestAlreadyExists,
        NoDeposit,
        NotPrime,
    },

    data() {

        return {
            extraServiceStatusText: EXTRA_SERVICE_STATUS_TEXT,
            extraServiceStyleStatusText: EXTRA_SERVICE_STYLE_STATUS_TEXT,
            extraServiceStatusIcon: EXTRA_SERVICE_STATUS_ICON,
            descriptionRequest: DESCRIPTION_REQUEST,
            preFixRequest: PRE_FIX_REQUEST,
            unitRequest: UNIT_REQUEST,
            createRequestStatus: EXTRA_SERVICE_REQUEST_STATUS,

            descriptionReview: "All requests will be manually reviewed and processed. So please describe in great detail for our team to consider.",
            descriptionProcessingTime: "After you submit your request successfully. We will process your request within 48 hours.",
        };
    },

    methods: {

        //#region Create request
        createRequest(data, callBack) {
            api.baseRequest(SETTINGS_EXTRA_SERVICE_API.CREATE_REQUEST, data)
                .then((res) => {
                    switch (res.errorCode) {
                        case EXTRA_SERVICE_REQUEST_STATUS.SUCCESS:
                            this.notificationSuccess('Request success !', 'Your request has been sent successfully. We will process your request in the next 48 hours');
                            if (callBack) callBack();
                            break;
                        case EXTRA_SERVICE_REQUEST_STATUS.CURRENT_LESS_THAN_REQUEST_VALUE:
                        case EXTRA_SERVICE_REQUEST_STATUS.REQUEST_ALREADY_EXISTS:
                        case EXTRA_SERVICE_REQUEST_STATUS.NO_DEPOSIT:
                        case EXTRA_SERVICE_REQUEST_STATUS.NOT_PRIME:
                            setTimeout(() => {
                                this.isShowErrorInformation = true;
                            }, 500);
                            this.errorCode = res.errorCode
                            break;
                    }
                    this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                })
                .catch(error => {
                    this.processCatchApiRequest(error, "Request failed ...")
                });
        },
        //#endregion 
    },
}